module.exports = __webpack_public_path__ + "images/grey3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/grey3.png
// module id = 0CHE
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15